import {
  branding_img,
  hr_consulting_img,
  product_design_img,
  software_dev_img
} from 'assets/images';
import ServiceItemCard from 'components/modules/cards/ServiceItemCard';
import { Button } from 'components/widgets/buttons';
import { CONNECT } from 'navigation/CONSTANTS';
import React from 'react';

function OurServicesList() {
  const items = services.map(({ title, btnLabel, texts, image, bgStyle = '' }, index) => (
    <ServiceItemCard
      key={index}
      custom_styles={(index + 1) % 2 === 0 ? ' md:flex-row-reverse ' : ''}
    >
      <div className="w-full md:w-1/2 h-98 relative">
        <div
          className={` w-full h-full  rounded-3xl hidden md:block bg-cover  ${bgStyle}`}
          style={{ backgroundImage: `url(${image})` }}
        ></div>
        <figure className="w-full ">
          <img src={image} className=" rounded-3xl  image-full object-contain m-auto md:hidden" />
        </figure>
      </div>
      <div className="w-full md:w-1/2 md:pl-4 flex flex-col ">
        <div className=" self-start">
          <h4 className="text-2xl md:text-4xl font-bold italic text-main  pb-4 absolute top-0 md:relative py-3">
            {index + 1}. {title}
          </h4>
        </div>
        {texts.map((pText, indx) => (
          <p key={indx} className="text-main text-justify text-base md:text-2xl font-normal my-2">
            {pText}
          </p>
        ))}

        <Button
          to={CONNECT}
          className="my-5 btn w-60 md:w-96 h-9 md:h-14  normal-case text-gold border border-gold bg-white hover:bg-gold hover:text-white hover:border-gold font-medium text-xs md:text-lg"
        >
          {btnLabel}
        </Button>
      </div>
    </ServiceItemCard>
  ));

  return (
    <div className="flex flex-col px-8 lg:px-40">
      <div className=" md:my-10">
        <h3 className="text-gold text-3xl md:text-5xl font-semibold md:font-bold text-left md:text-center my-5">
          We are good at what we do!
        </h3>
        <p className=" font-normal text-base md:text-2xl text-main text-left md:text-center">
          We offer a range of services to help individuals and organizations create a better world.
          Whether you are looking for help with branding, software development, product design, or
          HR consulting for technology talent, we have got you covered.
        </p>
      </div>
      {items}
    </div>
  );
}

const services = [
  {
    title: 'HR consulting',
    image: hr_consulting_img,
    texts: [
      ` We understand that your employees are the backbone of your business. That's why we offer HR consulting services that help you attract, retain, and develop top talent. `,
      `Our experts work closely with you to understand your unique needs and create a custom plan that aligns with your business strategy. From recruitment and onboarding to performance management and employee development, we are here to help you every step of the way.`
    ],
    btnLabel: `Make More Enquires`,
    bgStyle: ` bg-right`
  },
  {
    title: 'Product Design',
    image: product_design_img,
    texts: [
      `We believe that great product design is the foundation of a successful business. That's why we offer product design services that help you create functional and beautiful products. Our product design experts work closely with you to understand your business goals, audience, and unique challenges.`,
      `We then create a custom product design plan that meets your needs and delivers results. We help you create products that are not only easy to use but also visually stunning and memorable.`
    ],
    btnLabel: `Make More Enquires`,
    bgStyle: ` bg-center`
  },
  {
    title: 'Software Development',
    image: software_dev_img,
    texts: [
      `We understand that software is at the heart of modern businesses. That's why we offer software development services that help you build custom software solutions that meet your unique needs.`,
      ` Our software development experts work closely with you to understand your business requirements and create a custom software plan that aligns with your goals. Whether you need web development, mobile app development, or custom software solutions, we can help you achieve your vision. 
`
    ],
    btnLabel: `Make More Enquires`
  },
  {
    title: 'Branding',
    image: branding_img,
    texts: [
      ` We know that a strong brand is the key to success in today's competitive marketplace. That's why we offer branding services that help you define your unique value proposition and communicate it to your target audience`,
      `We work closely with you to understand your business, audience, and competition. We then create a custom brand strategy that aligns with your business goals and resonates with your customers`
    ],
    btnLabel: `Make More Enquires`,
    bgStyle: ` bg-center`
  }
];

export default OurServicesList;
